export default {
    passcode: "",
    verified: false,
  
    login(passcode) {
        this.verified = true;
        this.passcode = window.btoa(passcode);
    },

    logout() {
        this.verified = false
        this.passcode = ""
    }

    
  };
  